export default {
  data () {
    return {
      gimmickTimeout: null
    }
  },
  methods: {
    orderPaidGimmick (message) {
      let exists = document.getElementById('gimmick')
      if (!exists) {
        let total = 0
        if (message.total) {
          total = parseFloat(message.total)
        }
        let start = 0.3
        let step = 0.002
        if (total > 50) {
          start = 0.4
        }
        if (total > 100) {
          start = 0.8
          step = 0.005
        }
        if (total > 1000) {
          start = 1
          step = 0.005
        }
        this.gimmick('body', start, step)
      }
    },
    gimmick (el, start, step) {
      if (!start) {
        start = 0.3
      }
      if (!step) {
        step = 0.002
      }
      let gimmickAnimationFrame = null
      let exists = document.getElementById('gimmick')
      if (exists) {
        exists.parentNode.removeChild(exists)
        return false
      }
      let element = document.querySelector(el)
      let canvas = document.createElement('canvas'),
          ctx = canvas.getContext('2d'),
          focused = false
      canvas.width = window.innerWidth
      canvas.height = window.innerHeight
      canvas.id = 'gimmick'
      let coin = new Image()
      coin.src = this.$store.state.baseDomain + '/images/coins.png'
      // 440 wide, 40 high, 10 states
      coin.onload = function () {
        element.appendChild(canvas)
        focused = true
        drawloop()
      }
      let coins = []
      let fade = 0
      function drawloop() {
        if (focused) {
          gimmickAnimationFrame = requestAnimationFrame(drawloop)
        }
        fade += step
        let rand = start - fade
        ctx.clearRect(0, 0, canvas.width, canvas.height)
        if (Math.random() < rand) {
          coins.push({
            x: Math.random() * canvas.width | 0,
            y: -50,
            dy: 3,
            s: 0.5 + Math.random(),
            state: Math.random() * 10 | 0
          })
        }
        if (rand < 0 && coins.length <= 0) {
          focused = false
          cancelAnimationFrame(gimmickAnimationFrame)
          exists = document.getElementById('gimmick')
          if (exists) {
            exists.parentNode.removeChild(exists)
          }
        }
        let i = coins.length
        while (i--) {
          let x = coins[i].x
          let y = coins[i].y
          let s = coins[i].s
          let state = coins[i].state
          coins[i].state = (state > 9) ? 0 : state + 0.1
          coins[i].dy += 0.3
          coins[i].y += coins[i].dy
          ctx.drawImage(coin, 44 * Math.floor(state), 0, 44, 40, x, y, 44 * s, 40 * s)
          if (y > canvas.height) {
              coins.splice(i, 1)
          }
        }
      }
    }
  }
}